(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6397"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6397"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("d8HMG", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $990dfc566758140d$export$6503ec6e8aabbaf; }, function (v) { return $990dfc566758140d$export$6503ec6e8aabbaf = v; });
var $990dfc566758140d$export$6503ec6e8aabbaf;
var $990dfc566758140d$export$f7ad0328861e2f03;
"use strict";
var $990dfc566758140d$var$mapping = new Map();
function $990dfc566758140d$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$990dfc566758140d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $990dfc566758140d$var$resolve(id) {
    var resolved = $990dfc566758140d$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$990dfc566758140d$export$6503ec6e8aabbaf = $990dfc566758140d$var$register;
$990dfc566758140d$export$f7ad0328861e2f03 = $990dfc566758140d$var$resolve;

});

parcelRegister("3VV9c", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $2dd306457558c0ef$export$bdfd709ae4826697; }, function (v) { return $2dd306457558c0ef$export$bdfd709ae4826697 = v; });
var $2dd306457558c0ef$export$bdfd709ae4826697;
var $2dd306457558c0ef$export$c9e73fbda7da57b6;
var $2dd306457558c0ef$export$5a759dc7a1cfb72a;
"use strict";
var $2dd306457558c0ef$var$bundleURL = {};
function $2dd306457558c0ef$var$getBundleURLCached(id) {
    var value = $2dd306457558c0ef$var$bundleURL[id];
    if (!value) {
        value = $2dd306457558c0ef$var$getBundleURL();
        $2dd306457558c0ef$var$bundleURL[id] = value;
    }
    return value;
}
function $2dd306457558c0ef$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $2dd306457558c0ef$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $2dd306457558c0ef$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $2dd306457558c0ef$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$2dd306457558c0ef$export$bdfd709ae4826697 = $2dd306457558c0ef$var$getBundleURLCached;
$2dd306457558c0ef$export$c9e73fbda7da57b6 = $2dd306457558c0ef$var$getBaseURL;
$2dd306457558c0ef$export$5a759dc7a1cfb72a = $2dd306457558c0ef$var$getOrigin;

});

parcelRegister("bo64b", function(module, exports) {
document.querySelector(".btn.btn-hamburger").addEventListener("click", (e)=>{
    document.querySelector(".navigationDrawer").classList.remove("hide");
});
document.querySelector(".btn.navigationDrawer--closeBtn").addEventListener("click", (e)=>{
    document.querySelector(".navigationDrawer").classList.add("hide");
});
document.querySelectorAll('[data-element="navItem-expander"]').forEach((el)=>{
    el.querySelector(".navigationDrawer--navItemBtn").addEventListener("click", (e)=>{
        if (el.querySelector(".navigationDrawer--navItemExpanded").classList.contains("hide")) {
            el.querySelector(".navigationDrawer--navItemExpanded").classList.remove("hide");
            el.querySelector(".navigationDrawer--navItemBtnArrow").style.rotate = "180deg";
        } else {
            el.querySelector(".navigationDrawer--navItemExpanded").classList.add("hide");
            el.querySelector(".navigationDrawer--navItemBtnArrow").style.rotate = "0deg";
        }
    });
});

});

parcelRegister("dUzBg", function(module, exports) {
const $a20c1ec3db67aafa$var$btnTopNavigationEls = document.querySelectorAll(".btn.link-item");
const $a20c1ec3db67aafa$var$navigationMegaDropdownEl = document.querySelector(".navigationMegaDropdown");






const $a20c1ec3db67aafa$var$setValueDropDownNavigation = (keyElement)=>{
    const dropdownNavigation = {
        services: [
            {
                pageUrl: "intelligent-finance.html",
                logoSrc: new URL((parcelRequire("7rnJq"))),
                title: "Intelligent Finance Function"
            },
            {
                pageUrl: "manage-payroll.html",
                logoSrc: new URL((parcelRequire("9i9oT"))),
                title: "Managed Payroll"
            },
            {
                pageUrl: "consulting.html",
                logoSrc: new URL((parcelRequire("egaQs"))),
                title: "Consulting"
            }
        ],
        products: [
            {
                pageUrl: "people-management.html",
                logoSrc: new URL((parcelRequire("cm9d8"))),
                title: "People Management"
            },
            {
                pageUrl: "power-insight.html",
                logoSrc: new URL((parcelRequire("8vIR4"))),
                title: "Power Insight"
            },
            {
                pageUrl: "all-product.html",
                logoSrc: new URL((parcelRequire("fULtE"))),
                title: "All Product"
            }
        ]
    };
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelectorAll(".navigationMegaDropdownBtn").forEach((el, index)=>index > 0 && el.remove());
    dropdownNavigation[keyElement].forEach((value)=>{
        const navigationMegaDropdownBtn = $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelector(".navigationMegaDropdownBtn").cloneNode(true);
        navigationMegaDropdownBtn.href = value.pageUrl;
        navigationMegaDropdownBtn.querySelector('[data-element="logoNavigation"]').src = value.logoSrc;
        navigationMegaDropdownBtn.querySelector('[data-element="titleNavigation"]').textContent = value.title;
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelector(".navigationMegaDropdown--inner").appendChild(navigationMegaDropdownBtn);
    });
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.querySelectorAll(".navigationMegaDropdownBtn")[0].remove();
};
$a20c1ec3db67aafa$var$btnTopNavigationEls.forEach((el)=>{
    el.addEventListener("mouseenter", ()=>{
        el.classList.add("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "flex";
        $a20c1ec3db67aafa$var$setValueDropDownNavigation(el.getAttribute("data-element"));
    });
    el.addEventListener("mouseleave", ()=>{
        el.classList.remove("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "none";
    });
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.addEventListener("mouseenter", ()=>{
        el.classList.add("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "flex";
    });
    $a20c1ec3db67aafa$var$navigationMegaDropdownEl.addEventListener("mouseleave", ()=>{
        el.classList.remove("active");
        $a20c1ec3db67aafa$var$navigationMegaDropdownEl.style.display = "none";
    });
});

});
parcelRegister("7rnJq", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("h4dJK") + "battery-charging.ba1b1745.webp";

});

parcelRegister("9i9oT", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("h4dJK") + "settings-02.d69d69bd.webp";

});

parcelRegister("egaQs", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("h4dJK") + "life-buoy.285e728c.webp";

});

parcelRegister("cm9d8", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("h4dJK") + "people.d532b8d6.webp";

});

parcelRegister("8vIR4", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("h4dJK") + "grid.f0e29351.webp";

});

parcelRegister("fULtE", function(module, exports) {

module.exports = (parcelRequire("3VV9c")).getBundleURL("h4dJK") + "box.2a34708a.webp";

});


parcelRegister("2SvjK", function(module, exports) {
const $2188eaecfbdd828c$var$preferencePrivacyPopupEl = document.querySelector(".preferencePrivacy-popup");
const $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl = document.querySelector(".preferencePrivacy-popupDetail");
const $2188eaecfbdd828c$var$isCookies = document.cookie.split(";").filter((value)=>value === "_cookies=guest")[0] === "_cookies=guest" || document.cookie.split(";").filter((value)=>value === " _cookies=guest")[0] === " _cookies=guest";
if ($2188eaecfbdd828c$var$isCookies) $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
else $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.add("show");
// Cookies Button
document.querySelector(".btn-cookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.add("show");
// document.querySelector('.cookies-alert-popup').style.display = 'block'
});
document.querySelector(".cookies-accept-btn").addEventListener("click", ()=>{
    // document.querySelector('.cookies-alert-popup').style.display = 'none'
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupEl.querySelector(".btn.preferencePrivacy-popup--closeBtn").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
});
$2188eaecfbdd828c$var$preferencePrivacyPopupEl.querySelector(".btn.btn--rejectAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.add("show");
// document.cookie = '_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC'
});
$2188eaecfbdd828c$var$preferencePrivacyPopupEl.querySelector(".btn.btn--allowAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
document.querySelector(".btn.cookies-learn-more-btn").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupEl.classList.add("show");
    document.querySelector(".cookies-alert-popup").style.display = "none";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.preferencePrivacy-popupDetail--closeBtn").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--rejectAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--allowAllCookies").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});
$2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.querySelector(".btn.btn--preferencePrivacy-popupDetailConfirmPreference").addEventListener("click", ()=>{
    $2188eaecfbdd828c$var$preferencePrivacyPopupDetailEl.classList.remove("show");
    document.cookie = "_cookies=guest; expires=Thu, 18 Dec 2024 12:00:00 UTC";
});

});

var $b09ec2f91d52c88a$exports = {};


(parcelRequire("d8HMG")).register((parcelRequire("3VV9c")).getBundleURL("h4dJK"), JSON.parse('["h4dJK","book-a-demo.e20c5a3d.js","giQtv","battery-charging.ba1b1745.webp","23FFC","settings-02.d69d69bd.webp","eQ5EQ","life-buoy.285e728c.webp","1BQWm","people.d532b8d6.webp","eSkdY","grid.f0e29351.webp","9Glg9","box.2a34708a.webp","9cmfi","book-a-demo.9fb7a123.js"]'));

/* eslint-disable no-undef */ parcelRequire("bo64b");
parcelRequire("dUzBg");
parcelRequire("2SvjK");
parcelRequire("aqgMQ");
const $cca59f563952d76d$var$chevronDownIcon = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 4.5L6 7.5L9 4.5" stroke="#94A3B8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelectorAll(".link-item .arrow-down").forEach((el)=>{
    el.innerHTML += $cca59f563952d76d$var$chevronDownIcon;
});
const $cca59f563952d76d$var$hamburgerIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12H21M3 6H21M3 18H21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelector(".btn-hamburger").innerHTML += $cca59f563952d76d$var$hamburgerIcon;
const $cca59f563952d76d$var$preHeadingIcon = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="16" fill="white" fill-opacity="0.2"/>
<g opacity="0.5">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.8346 14.2283C13.2723 13.8582 14.3346 12.5532 14.3346 11C14.3346 9.15901 12.8423 7.66663 11.0013 7.66663C9.16035 7.66663 7.66797 9.15901 7.66797 11C7.66797 12.5532 8.73028 13.8582 10.168 14.2283V23.5C10.168 23.9602 10.5411 24.3333 11.0013 24.3333C11.4615 24.3333 11.8346 23.9602 11.8346 23.5V14.2283Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.668 21C17.668 19.4468 18.7303 18.1417 20.168 17.7716V12.6666C20.168 12.4456 20.0802 12.2336 19.9239 12.0774C19.7676 11.9211 19.5556 11.8333 19.3346 11.8333H16.8346C16.3744 11.8333 16.0013 11.4602 16.0013 11C16.0013 10.5397 16.3744 10.1666 16.8346 10.1666H19.3346C19.9977 10.1666 20.6336 10.43 21.1024 10.8989C21.5712 11.3677 21.8346 12.0036 21.8346 12.6666V17.7716C23.2723 18.1417 24.3346 19.4468 24.3346 21C24.3346 22.8409 22.8422 24.3333 21.0013 24.3333C19.1604 24.3333 17.668 22.8409 17.668 21Z" fill="white"/>
</g>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.6667 21C17.6667 19.4468 18.729 18.1417 20.1667 17.7716V12.6666C20.1667 12.4456 20.0789 12.2337 19.9226 12.0774C19.7663 11.9211 19.5543 11.8333 19.3333 11.8333H16.8333C16.3731 11.8333 16 11.4602 16 11C16 10.5397 16.3731 10.1666 16.8333 10.1666H19.3333C19.9964 10.1666 20.6323 10.43 21.1011 10.8989C21.5699 11.3677 21.8333 12.0036 21.8333 12.6666V17.7716C23.271 18.1417 24.3333 19.4468 24.3333 21C24.3333 22.8409 22.8409 24.3333 21 24.3333C19.1591 24.3333 17.6667 22.8409 17.6667 21Z" fill="white"/>
</svg>`;
document.querySelector(".contents__booking--preHeadingIcon").innerHTML += $cca59f563952d76d$var$preHeadingIcon;
const $cca59f563952d76d$var$arrowUpRightIcon = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.66602 11.3333L11.3327 4.66663M11.3327 4.66663H4.66602M11.3327 4.66663V11.3333" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelectorAll(".visit-us--link").forEach((el)=>{
    el.innerHTML += $cca59f563952d76d$var$arrowUpRightIcon;
});
const $cca59f563952d76d$var$arrowIcon = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 6L8 10L12 6" stroke="#CBD5E1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
document.querySelector(".contactUs--inputPhoneArrowIcon").innerHTML += $cca59f563952d76d$var$arrowIcon;
document.querySelector(".bookDemoForm").addEventListener("submit", function(e) {
    e.preventDefault();
    Toastify({
        text: "The book a demo submission form has been successfully sent!",
        duration: 3000,
        gravity: "top",
        position: "center",
        stopOnFocus: true,
        style: {
            background: "#05a6f0",
            fontFamily: '"Montserrat", sans-serif',
            fontSize: "14px"
        }
    }).showToast();
    setTimeout(()=>{
        document.querySelector(".bookDemoForm").reset();
        document.querySelector(".contactUs--inputPhoneContainer .contactUs--contentEditable").textContent = "";
    }, 1500);
});
document.querySelector(".contactUs--inputPhoneContainer .contactUs--contentEditable").addEventListener("keypress", (e)=>{
    const regex = /\d/;
    const phoneCode = document.querySelector(".contactUs--inputPhoneContainer .contactUs--inputPhoneArrow p").textContent;
    const symbol = String.fromCharCode(e.keyCode);
    if (!regex.test(symbol)) e.preventDefault();
    setTimeout(()=>{
        document.querySelector(".contactUs--inputPhoneContainer input").value = phoneCode + e.target.textContent;
    }, 1000);
});
document.querySelector(".contactUs--inputPhoneContainer .contactUs--contentEditable").addEventListener("keydown", function(event) {
    const phoneCode = document.querySelector(".contactUs--inputPhoneContainer .contactUs--inputPhoneArrow p").textContent;
    if (event.key === "Backspace") setTimeout(()=>{
        if (event.target.textContent === "") document.querySelector(".contactUs--inputPhoneContainer input").value = "";
        else document.querySelector(".contactUs--inputPhoneContainer input").value = phoneCode + event.target.textContent;
    }, 1000);
});

})();
//# sourceMappingURL=book-a-demo.e20c5a3d.js.map
